import {DynamicTabsDirective} from '../../directive/dynamic-tabs/dynamictab.component';
import {TabComponent} from '../../tab/tab/tab.component';
import {TabsComponent} from '../../tab/tabs/tabs.component';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import { SignatureComponent } from '../../component/signature/signature.component';
@NgModule({
  declarations: [
    DynamicTabsDirective,
    TabsComponent,
    TabComponent,
    SignatureComponent
  ],
  exports: [
    DynamicTabsDirective,
    TabsComponent,
    TabComponent,
    SignatureComponent
  ],
  entryComponents: [
    TabComponent,
    TabsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
  ],
  providers: [
    TabsComponent
  ],
  bootstrap: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/module/shared/shared.module.ts